import { render, staticRenderFns } from "./TransportationStatus.vue?vue&type=template&id=4e4411b1"
import script from "./TransportationStatus.vue?vue&type=script&lang=js"
export * from "./TransportationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports